import { Trans } from '@lingui/react/macro';
import { type PropsWithChildren, type ReactNode } from 'react';

import Warning from '@/assets/svg/warning.svg?react';
import { Title } from '@/components/typography';
import { cn } from '@/lib/utils';

type Props = {
  message?: ReactNode;
  detail?: ReactNode;
  headingLevel?: 1 | 2;
};

const PageError = ({ message, detail, headingLevel = 1, children }: PropsWithChildren<Props>) => {
  return (
    <div className="flex w-full max-w-187.5 min-w-75 flex-col items-center">
      <div
        className={cn(
          'flex w-full flex-col flex-wrap items-center gap-6 px-6 py-[20%] text-center',
        )}
      >
        <Warning className="size-25 shrink-0" />
        <Title level={headingLevel} weight="light">
          {message ? message : <Trans>An unknown error occurred.</Trans>}
        </Title>
        {detail != null && (
          <Title level={4} weight="light" className="max-w-175">
            {detail}
          </Title>
        )}
        {children}
      </div>
    </div>
  );
};

export default PageError;
